/* Ice Season theme */
(function () {
  'use strict';

  var T = window.theme || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    format = String(format || T.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    function fmt(n, d, ts, ds) {
      ts = ts === undefined ? ',' : ts; ds = ds === undefined ? '.' : ds;
      var s = (n / 100).toFixed(d).split('.');
      return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (s[1] ? ds + s[1] : '');
    }
    if (!m) return fmt(cents, 2);
    var v;
    switch (m[1]) {
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(m[0], v);
  }

  /* ---------- cart helpers ---------- */
  function cartUrl(action) {
    var base = (T.routes && T.routes.cart) || '/cart';
    return action ? base + '/' + action + '.js' : base + '.js';
  }
  function getCart() {
    return fetch(cartUrl(), { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  /* A free gift = line with the _gift property, or any product priced 0 (free gloves). */
  function isGiftLine(it) {
    var p = it.properties || {};
    return !!p._gift || it.original_price === 0;
  }
  /* masks = items that are not free gifts and not the upsell; gifts = gift variants already in cart */
  function cartGiftState(cart) {
    var st = { masks: 0, gifts: {} };
    ((cart && cart.items) || []).forEach(function (it) {
      var p = it.properties || {};
      if (isGiftLine(it)) st.gifts[it.variant_id] = true;
      else if (!p._upsell) st.masks += it.quantity;
    });
    return st;
  }

  /* Cart page: every free gift is max 1 per order, and is removed when the
     customer no longer has enough masks for it. */
  function guardGifts() {
    var cartForm = $('[data-cart-form]');
    if (!cartForm) return;
    var defMin = +cartForm.dataset.giftMin || 2;
    try {
      var last = +sessionStorage.getItem('giftFixAt') || 0;
      if (Date.now() - last < 4000) return; /* never loop reloads */
    } catch (e) {}
    getCart().then(function (cart) {
      var st = cartGiftState(cart), seen = {}, fixes = [];
      cart.items.forEach(function (it, i) {
        var p = it.properties || {};
        if (!isGiftLine(it)) return;
        var min = +p._gift_min || defMin;
        var allowed = (st.masks >= min && !seen[it.variant_id]) ? 1 : 0;
        if (allowed) seen[it.variant_id] = true;
        if (it.quantity !== allowed) fixes.push({ line: i + 1, quantity: allowed });
      });
      if (!fixes.length) return;
      try { sessionStorage.setItem('giftFixAt', String(Date.now())); } catch (e) {}
      /* highest line first so the other line numbers don't shift */
      fixes.sort(function (a, b) { return b.line - a.line; });
      fixes.reduce(function (p, f) {
        return p.then(function () {
          return fetch(cartUrl('change'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(f)
          });
        });
      }, Promise.resolve()).then(function () { window.location.reload(); });
    }).catch(function () {});
  }

  /* ---------- announcement rotator ---------- */
  function initRotators(root) {
    $$('[data-rotator]', root).forEach(function (el) {
      if (el._rot) clearInterval(el._rot);
      var s = $$('.announce__msg', el);
      if (s.length < 2) return;
      var i = 0;
      el._rot = setInterval(function () {
        var p = s[i];
        p.classList.remove('on'); p.classList.add('out');
        setTimeout(function () { p.classList.remove('out'); }, 500);
        i = (i + 1) % s.length;
        s[i].classList.add('on');
      }, +el.dataset.speed || 4000);
    });
  }

  /* ---------- infinite marquees ---------- */
  function initMarquees(root) {
    $$('[data-marquee]', root).forEach(function (el) {
      if (el._unit === undefined) el._unit = el.innerHTML;
      var unit = el._unit;
      if (!unit.trim()) return;
      el.innerHTML = unit;
      var n = 1;
      while (el.scrollWidth < window.innerWidth && n < 40) { el.innerHTML += unit; n++; }
      el.innerHTML += el.innerHTML;
      var speed = +el.dataset.speed || 60;
      el.style.animationDuration = Math.max(8, el.scrollWidth / 2 / speed) + 's';
      $$('video', el).forEach(function (v) { v.muted = true; v.setAttribute('playsinline', ''); var p = v.play(); if (p && p.catch) p.catch(function () {}); });
    });
  }

  /* ---------- countdowns ---------- */
  var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  function countdownTarget() {
    var c = T.countdown || {};
    if (!c.date) return null;
    var d = String(c.date).trim();
    var t = new Date(d.length <= 10 ? d + 'T00:00:00' : d.replace(' ', 'T'));
    if (isNaN(t)) return null;
    var rep = +c.repeat || 0, now = new Date();
    if (rep > 0) { while (t < now) t = new Date(t.getTime() + rep * 864e5); }
    return t;
  }
  var cdTimer;
  function initCountdowns(root) {
    var t = countdownTarget();
    var shortD = '', longD = '';
    if (t) {
      shortD = MONTHS[t.getMonth()].slice(0, 3) + ' ' + t.getDate();
      longD = (MONTHS[t.getMonth()] + ' ' + t.getDate()).toUpperCase();
    }
    $$('[data-date-tpl]', root).forEach(function (el) {
      el.textContent = el.dataset.dateTpl.replace(/\[DATE\]/g, longD).replace(/\[date\]/g, shortD);
    });
    function tick() {
      var s = t ? Math.max(0, (t - new Date()) / 1000) : 0;
      var v = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: Math.floor(s % 60) };
      $$('[data-cd]').forEach(function (e) { e.textContent = String(v[e.dataset.cd]).padStart(2, '0'); });
    }
    tick();
    clearInterval(cdTimer);
    cdTimer = setInterval(tick, 1000);
  }

  /* ---------- reveal on scroll ---------- */
  var revealIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in', 'is-in'); revealIO.unobserve(e.target); }
    });
  }, { threshold: 0.12 }) : null;
  function initReveal(root) {
    $$('.reveal, [data-zoom-in]', root).forEach(function (el) {
      if (!revealIO) { el.classList.add('in', 'is-in'); return; }
      revealIO.observe(el);
    });
  }

  /* ---------- autoplay videos (only when visible) ---------- */
  var videoIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else v.pause();
    });
  }, { threshold: 0.1 }) : null;
  function initVideos(root) {
    $$('video[autoplay]', root).forEach(function (v) {
      v.muted = true; v.setAttribute('playsinline', ''); v.setAttribute('muted', '');
      if (videoIO) videoIO.observe(v);
    });
  }

  /* ---------- falling snow ---------- */
  function initSnow(root) {
    $$('[data-snow]', root).forEach(function (c) {
      if (c._snow) return;
      c._snow = true;
      var x = c.getContext('2d'), flakes = [], dpr = Math.min(window.devicePixelRatio || 1, 2), running = true;
      function size() {
        c.width = c.offsetWidth * dpr; c.height = c.offsetHeight * dpr;
        flakes = [];
        var n = Math.min(140, Math.round(c.offsetWidth / 8));
        for (var i = 0; i < n; i++) flakes.push({ x: Math.random() * c.width, y: Math.random() * c.height, r: (Math.random() * 2 + 0.6) * dpr, v: Math.random() * 0.6 + 0.3, d: Math.random() * 6.28 });
      }
      function draw() {
        if (!document.body.contains(c)) return;
        if (running) {
          x.clearRect(0, 0, c.width, c.height);
          x.fillStyle = 'rgba(255,255,255,.75)';
          flakes.forEach(function (p) {
            p.y += p.v * dpr; p.d += 0.01; p.x += Math.sin(p.d) * 0.4;
            if (p.y > c.height) { p.y = -5; p.x = Math.random() * c.width; }
            x.beginPath(); x.arc(p.x, p.y, p.r, 0, 7); x.fill();
          });
        }
        requestAnimationFrame(draw);
      }
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { running = es[0].isIntersecting; }).observe(c);
      size(); draw();
      window.addEventListener('resize', size);
    });
  }

  /* ---------- image panels ---------- */
  function initPanels(root) {
    $$('[data-panels]', root).forEach(function (wrap) {
      var panels = $$('[data-panel]', wrap);
      function sizeIt() {
        var row = getComputedStyle(wrap).flexDirection === 'row';
        var gaps = (panels.length - 1) * 14;
        var grow = 2.6 + (panels.length - 1);
        wrap.style.setProperty('--pw', row ? ((wrap.clientWidth - gaps) * 2.6 / grow) + 'px' : '100%');
      }
      panels.forEach(function (p) {
        function on() { panels.forEach(function (q) { q.classList.toggle('is-on', q === p); }); }
        p.addEventListener('mouseenter', on);
        p.addEventListener('click', on);
      });
      sizeIt();
      window.addEventListener('resize', sizeIt);
    });
  }

  /* ---------- scroll reading text ---------- */
  var readers = [];
  function initScrollText(root) {
    $$('[data-scroll-text]', root).forEach(function (sec) {
      var p = $('[data-scroll-words]', sec);
      if (!p || p._done) return;
      p._done = true;
      var words = p.textContent.trim().split(/\s+/);
      p.innerHTML = words.map(function (w) {
        var hot = w.charAt(0) === '*';
        var clean = w.replace(/\*/g, '').replace(/&/g, '&amp;').replace(/</g, '&lt;');
        return '<span' + (hot ? ' class="o"' : '') + '>' + clean + '</span>';
      }).join(' ');
      readers.push({ sec: sec, spans: $$('span', p), bar: $('[data-scroll-bar]', sec) });
    });
    onReadScroll();
  }
  function onReadScroll() {
    readers.forEach(function (r) {
      if (!document.body.contains(r.sec)) return;
      var rect = r.sec.getBoundingClientRect();
      var total = r.sec.offsetHeight - window.innerHeight;
      var prog = document.body.classList.contains('is-editor') ? 1 : Math.min(1, Math.max(0, -rect.top / (Math.max(total, 1) * 0.85)));
      var n = Math.round(prog * r.spans.length);
      r.spans.forEach(function (s, i) { s.classList.toggle('lit', i < n); });
      if (r.bar) r.bar.style.width = (prog * 100) + '%';
    });
  }
  window.addEventListener('scroll', onReadScroll, { passive: true });

  /* ---------- product page ---------- */
  function initProduct(root) {
    $$('[data-product-section]', root).forEach(function (sec) {
      var dataEl = $('[data-product-data]', sec);
      if (!dataEl) return;
      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var opts = (data.options || []).filter(function (o) { return o && o.id; });
      var form = $('form', sec);
      var atc = $('[data-atc]', sec);
      var atcPrice = $('[data-atc-price]', sec);
      var errBox = $('[data-form-error]', sec);
      var tiers = $$('[data-tier]', sec);
      var gifts = $$('[data-gift]', sec);
      var unlock = $('[data-unlock-msg]', sec);
      var upsell = $('[data-upsell]', sec);
      var upInput = upsell ? $('[data-upsell-input]', upsell) : null;
      var stickyBar = $('[data-sticky-atc]', sec);
      var stickyPrice = $('[data-sticky-price]', sec);

      /* gallery */
      var slides = $$('[data-slide]', sec), thumbs = $$('[data-thumb]', sec);
      thumbs.forEach(function (b) {
        b.addEventListener('click', function () {
          var i = +b.dataset.thumb;
          slides.forEach(function (s, j) {
            s.classList.toggle('is-on', j === i);
            var v = $('video', s); if (v) { if (j === i) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); }
          });
          thumbs.forEach(function (t, j) { t.classList.toggle('is-on', j === i); });
        });
      });

      /* default pick = current product */
      var def = -1;
      opts.forEach(function (o, i) { if (def < 0 && o.id === data.currentVariant) def = i; });
      if (def < 0) opts.forEach(function (o, i) { if (def < 0 && o.productId === data.productId) def = i; });
      if (def < 0) def = 0;
      var picks = [];
      for (var k = 0; k < 10; k++) picks.push(def);

      var tier = -1;
      tiers.forEach(function (t, i) { if (tier < 0 && t.classList.contains('is-on')) tier = i; });
      if (tier < 0) tier = 0;

      function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
      function thumbHTML(o) { return o && o.image ? '<img src="' + esc(o.image) + '" alt="" loading="lazy" width="44" height="44">' : '<span class="pick__ph"></span>'; }

      function buildBody(t) {
        var body = $('[data-tier-body]', t);
        if (!body) return;
        var q = +t.dataset.qty || 1;
        if (!opts.length) { body.innerHTML = ''; return; }
        var html = '';
        for (var m = 0; m < q; m++) {
          var label = q === 1 ? (data.faceLabel || 'FACE') : (data.maskLabel || 'MASK') + ' ' + (m + 1);
          html += '<div class="pick"><span>' + esc(label) + '</span><span class="pick__thumb">' + thumbHTML(opts[picks[m]]) + '</span>';
          if (opts.length > 1) {
            html += '<select data-pick="' + m + '" aria-label="' + esc(label) + '">';
            opts.forEach(function (o, i) {
              html += '<option value="' + i + '"' + (i === picks[m] ? ' selected' : '') + (o.available ? '' : ' disabled') + '>' + esc(o.title) + (o.available ? '' : ' — Sold out') + '</option>';
            });
            html += '</select>';
          } else {
            html += '<span class="pick__name">' + esc(opts[0].title) + '</span>';
          }
          html += '</div>';
        }
        body.innerHTML = html;
      }

      function selectTier(i) {
        tier = i;
        tiers.forEach(function (t, j) {
          var on = j === i;
          t.classList.toggle('is-on', on);
          t.setAttribute('aria-checked', on ? 'true' : 'false');
          if (on) buildBody(t); else { var b = $('[data-tier-body]', t); if (b) b.innerHTML = ''; }
        });
        update();
      }

      tiers.forEach(function (t, i) {
        t.addEventListener('click', function (e) {
          if (e.target.closest('select')) return;
          if (tier !== i) selectTier(i);
        });
        t.addEventListener('keydown', function (e) {
          if ((e.key === 'Enter' || e.key === ' ') && e.target === t) { e.preventDefault(); selectTier(i); }
        });
        t.addEventListener('change', function (e) {
          var s = e.target.closest('[data-pick]');
          if (!s) return;
          var m = +s.dataset.pick;
          picks[m] = +s.value;
          var th = s.parentNode.querySelector('.pick__thumb');
          if (th) th.innerHTML = thumbHTML(opts[picks[m]]);
          var o = opts[picks[m]]; if (o && o.image) { var k = String(o.image).split('?')[0].split('/').pop(); slides.forEach(function (sl, j) { var im = sl.querySelector('img'); if (im && (im.getAttribute('src') || '').split('?')[0].split('/').pop() === k && thumbs[j]) thumbs[j].click(); }); }
        });
      });

      if (upsell && upInput) {
        upInput.addEventListener('change', function () { upsell.classList.toggle('is-on', upInput.checked); update(); });
      }

      function currentQty() { return tiers.length ? (+tiers[tier].dataset.qty || 1) : 1; }
      function currentPrice() {
        if (tiers.length) return +tiers[tier].dataset.price || 0;
        return typeof data.price === 'number' ? data.price : null;
      }

      function update() {
        var q = currentQty();
        var price = currentPrice();
        if (price !== null && upsell && upInput && upInput.checked) price += +upsell.dataset.price || 0;
        if (price !== null) {
          if (atcPrice) atcPrice.textContent = formatMoney(price);
          if (stickyPrice) stickyPrice.textContent = (tiers.length ? tiers[tier].dataset.label + ' · ' : '') + formatMoney(price);
        }
        /* gifts */
        var next = null;
        gifts.forEach(function (g) {
          var min = +g.dataset.min || 1, on = q >= min, sm = $('small', g);
          g.classList.toggle('is-on', on);
          g.classList.toggle('is-off', !on);
          if (sm) sm.textContent = on ? sm.dataset.on : sm.dataset.off;
          if (!on && (next === null || min < next)) next = min;
        });
        if (unlock && gifts.length) {
          if (next === null) unlock.textContent = unlock.dataset.all || '';
          else {
            var names = gifts.filter(function (g) { return (+g.dataset.min || 1) === next; }).map(function (g) { return g.dataset.title; }).join(' + ');
            unlock.textContent = (unlock.dataset.next || '').replace('[count]', next - q).replace('[gifts]', names);
          }
        }
      }

      function showError(msg) {
        if (!errBox) return;
        errBox.textContent = msg;
        errBox.hidden = !msg;
      }

      if (form && atc) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (atc.disabled) return;
          showError('');
          var q = currentQty();
          var items = [];
          if (opts.length) {
            var counts = {}, order = [];
            for (var m = 0; m < q; m++) {
              var o = opts[picks[m]] || opts[0];
              if (!counts[o.id]) { counts[o.id] = 0; order.push(o.id); }
              counts[o.id]++;
            }
            order.forEach(function (id) {
              var it = { id: id, quantity: counts[id] };
              if (q > 1) it.properties = { _bundle: q + ' pack' };
              items.push(it);
            });
          } else {
            var idInput = form.querySelector('[name="id"]');
            items.push({ id: +idInput.value, quantity: q });
          }
          if (upsell && upInput && upInput.checked && upsell.dataset.variant) items.push({ id: +upsell.dataset.variant, quantity: 1, properties: { _upsell: 'yes' } });

          atc.classList.add('is-loading');
          /* Free gifts: max 1 of each per order. Read the cart first so a gift that is
             already there is never added again, and count masks already in the cart. */
          getCart().then(function (cart) {
            var inCart = cartGiftState(cart);
            var total = inCart.masks + q;
            gifts.forEach(function (g) {
              var min = +g.dataset.min || 1, vid = +g.dataset.variant;
              if (!vid || total < min || inCart.gifts[vid]) return;
              inCart.gifts[vid] = true;
              items.push({ id: vid, quantity: 1, properties: { _gift: 'Free gift', _gift_min: String(min) } });
            });
            return fetch(cartUrl('add'), {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({ items: items })
            });
          }).then(function (r) {
            return r.json().then(function (j) { return { ok: r.ok, j: j }; });
          }).then(function (res) {
            if (!res.ok) throw res.j;
            var root = (T.routes && T.routes.root) || '/';
            window.location.href = data.afterAdd === 'checkout' ? root.replace(/\/?$/, '/') + 'checkout' : ((T.routes && T.routes.cart) || '/cart');
          }).catch(function (err) {
            atc.classList.remove('is-loading');
            showError((err && (err.description || err.message)) || 'Something went wrong. Please try again.');
          });
        });
      }

      /* sticky bar (mobile) */
      if (stickyBar && atc && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          var e = es[0];
          stickyBar.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(atc);
        var sb = $('[data-sticky-btn]', stickyBar);
        if (sb) sb.addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit(); else atc.click();
        });
      }

      if (tiers.length) selectTier(tier); else update();
    });
  }

  /* ---------- faq ---------- */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.qa__q');
    if (!q) return;
    var item = q.closest('.qa'), list = item.parentNode, open = item.classList.contains('is-open');
    $$('.qa', list).forEach(function (x) { x.classList.remove('is-open'); var b = $('.qa__q', x); if (b) b.setAttribute('aria-expanded', 'false'); });
    if (!open) { item.classList.add('is-open'); q.setAttribute('aria-expanded', 'true'); }
  });

  /* ---------- mobile drawer ---------- */
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-drawer-open]');
    var closeBtn = e.target.closest('[data-drawer-close]');
    var d = $('[data-drawer]');
    if (!d) return;
    if (openBtn) { d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
    else if (closeBtn || (e.target.closest('.drawer__nav a'))) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = $('[data-drawer].is-open');
    if (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  });

  /* ---------- cart page: auto update on qty change ---------- */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-cart-qty]')) return;
    var f = e.target.closest('form');
    if (f) f.submit();
  });

  /* ---------- account: forgot password toggle ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-toggle-recover]');
    if (!t) return;
    var r = document.getElementById('recover');
    if (r) { e.preventDefault(); r.style.display = 'block'; r.scrollIntoView({ behavior: 'smooth' }); }
  });

  /* ---------- init ---------- */
  function initAll(root) {
    root = root || document;
    initRotators(root);
    initMarquees(root);
    initCountdowns(root);
    initReveal(root);
    initVideos(root);
    initSnow(root);
    initPanels(root);
    initScrollText(root);
    initProduct(root);
  }

  var lastW = window.innerWidth, rT;
  window.addEventListener('resize', function () {
    if (window.innerWidth === lastW) return;
    lastW = window.innerWidth;
    clearTimeout(rT);
    rT = setTimeout(function () { initMarquees(document); }, 200);
  });

  function boot() { initAll(document); guardGifts(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* theme editor support */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
